module.exports = __webpack_public_path__ + "static/media/mouton_03_thumb.9e277bb8.png";